export const environment = {
  production: true,
  basePath: "/",
  LOG_LEVEL: 4
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts